/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=202b1b93&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=202b1b93&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202b1b93"]])

export default __exports__